// client/src/pages/Admin/ProjectManager/components/ProjectSkeleton.tsx
/**
 * PROJECT SKELETON COMPONENT
 * 
 * Loading skeleton for project cards.
 * 
 * @module ProjectManager/Components/ProjectSkeleton
 */

import React from 'react';

interface ProjectSkeletonProps {
    count?: number;
}

export const ProjectSkeleton: React.FC<ProjectSkeletonProps> = ({ count = 6 }) => {
    return (
        <div className="skeleton-container">
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className="skeleton-card">
                    <div className="skeleton-header">
                        <div className="skeleton-checkbox" />
                        <div className="skeleton-title" />
                    </div>
                    <div className="skeleton-meta">
                        <div className="skeleton-badge" />
                        <div className="skeleton-badge" />
                        <div className="skeleton-badge" />
                    </div>
                    <div className="skeleton-description">
                        <div className="skeleton-line" />
                        <div className="skeleton-line" />
                        <div className="skeleton-line" />
                    </div>
                    <div className="skeleton-footer">
                        <div className="skeleton-stat" />
                        <div className="skeleton-actions" />
                    </div>
                </div>
            ))}
        </div>
    );
};